<template>
    <div>
        <LocationSelector :locations="locations" :value="value.locations" @input="updateLocations" />
        <CallTypesSelector :value="value.call_types" @input="updateCallTypes" />
        <div class="wrapper">
            <SelectBox
                id="forAT_AddWidget-duration"
                :placeholder="$t('dashboard.widgetType5.durationType')"
                :value="value.duration"
                :options="durations"
                @input="updateDuration"
            />
        </div>
    </div>
</template>

<script>
import SelectBox from './../../common/SelectBox.vue';
import LocationSelector from './common/LocationSelector';
import CallTypesSelector from './common/CallTypesSelector';
import { translateOptions, durations as durationsArray, createUpdaters } from '../widgetHelpers';

export default {
    components: {
        CallTypesSelector,
        LocationSelector,
        SelectBox,
    },

    props: {
        locations: {
            type: Array,
            required: true,
        },

        value: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * Returns a list of options for durations dropdown
         * {{ name: string, value: number}[]}
         */
        durations() {
            return translateOptions(this.$t.bind(this), durationsArray);
        },
    },

    methods: createUpdaters('duration', 'call_types', 'locations'),
};
</script>
